module.exports = __webpack_public_path__ + "static/media/hand-peace.b7f307b6.svg";